import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=6e76f5de&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/borno-cct/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e76f5de')) {
      api.createRecord('6e76f5de', component.options)
    } else {
      api.reload('6e76f5de', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=6e76f5de&", function () {
      api.rerender('6e76f5de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/setting/lga/edit.vue"
export default component.exports